import React, { useEffect, useState } from 'react'
import Modal from "react-modal";
import { Button } from "reactstrap";
import base_url from "../../api/bootapi";
import axios from "axios";
import Swal from "sweetalert2";
import { useForm } from "react-hook-form";

import "./PaymentModal.css";

const RemarkModal = (
    {
        remark,
        isOpen,
        onRequestClose,
        enquiry_id,
        jwtToken,
        setbackdropopen,
        fetchEnquiryData,
    }
) => {

    const {
        register,
        formState: { errors },
        setValue,
        handleSubmit
    } = useForm();
    const customStylesone = {
        content: {
            top: "50%",
            left: "50%",
            right: "auto",
            bottom: "auto",
            marginRight: "-50%",
            transform: "translate(-50%, -50%)",
            border: "none",
            padding: "28px 36px"
        },
        overlay: {
            zIndex: 999,
            backdropFilter: "blur(4px)",
            backgroundColor: 'rgba(0, 0, 0, 0.1)'
        }
    };


    const onSubmit = (data2) => {
        // const formData = new FormData();

        let remarks = data2.remarks;



        let enquiryData = {

            remarks

        };


        // formData.append("data", JSON.stringify(enquiryData));
        setbackdropopen(true);

        axios
            .put(
                `${base_url.api1}/tourapp/add_remarks?id=` + enquiry_id,
                enquiryData,

            )
            .then(
                (response) => {
                    if (response.status === 200) {
                        setbackdropopen(false);
                        resetForm()
                        onRequestClose();
                        Swal.fire({
                            position: "center",
                            icon: "success",
                            title: "Remark added Successful",
                            showCloseButton: true,
                            showConfirmButton: false,
                        });
                        fetchEnquiryData();
                    } else {
                        setbackdropopen(false);
                        resetForm()

                        onRequestClose();
                        Swal.fire({
                            position: "center",
                            icon: "error",
                            title: "failed",
                            showCloseButton: true,
                            showConfirmButton: false,
                        });
                    }
                },
                (error) => {
                    setbackdropopen(false);
                    resetForm()

                    onRequestClose();
                    Swal.fire({
                        icon: "error",
                        title: "Oops...",
                        text: "Something went wrong!",
                        showConfirmButton: false,
                        showCloseButton: true,
                    });
                }
            );

    };

    console.log(remark)

    const resetForm = () => {
        setValue('remarks', remark)
        setRemarkText(remark || '');
    }

    const [remarkText, setRemarkText] = useState('');

    useEffect(() => {
        setValue('remarks', remark)
        setRemarkText(remark || '');
    }, [remark]);


    return (
        <Modal
            isOpen={isOpen}
            onRequestClose={onRequestClose}
            style={customStylesone}
            contentLabel="Payment Modal"
        >
            <div className="payment_modal">
                <p className="card_head">Add Remark</p>


                <form onSubmit={handleSubmit(onSubmit)} id="myForm">
                    <div>
                        <div className="form-group creatadmin">


                            {/* Amount Input */}
                            <div className="form-group" style={{ marginTop: "15px" }}>
                                <label htmlFor="amount">
                                    Remark<span style={{ color: "red" }}>*</span>:
                                </label>
                                <textarea
                                    {...register("remarks", { required: true })}
                                    value={remarkText}
                                    onChange={(e) => setRemarkText(e.target.value)}
                                    className="form-control"
                                    rows={6}
                                />
                            </div>






                        </div>
                        <br />
                        <div
                            style={{
                                display: "flex",
                                gap: "12px",
                                justifyContent: "flex-end"
                            }}
                        >
                            <Button
                                type="button"
                                onClick={() => { resetForm(); onRequestClose() }}
                                className="btn"
                            >
                                Cancel
                            </Button>
                            <Button
                                type="submit"
                                color="primary"
                                className="btn btn-primary"
                            >
                                Submit
                            </Button>
                        </div>
                    </div>
                </form>

            </div>

        </Modal>
    )
}

export default RemarkModal